import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ClientData } from '../providers/client';
import { Observable } from 'rxjs/Observable';

@Pipe({
  name: 'translateClientConfig',
  pure: true
})
@Injectable()
export class TranslateClientConfigPipe implements PipeTransform {

  constructor(
    private clientData: ClientData
  ) { }

  transform(moduleName: any, clientId: string): Observable<any> {
    return this.clientData.getConfigByModule(clientId, moduleName);
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pipes/translate-client-config.ts